<template>
    <div
        class="flex flex-wrap lg:flex-nowrap items-center gap-2"
    >
        <VcButton
            v-if="isCategoryReassignable"
            ref="reassignAccountsButtonRef"
            color="primary-alternative"
            icon="vc-lc-repeat"
            type="borderless"
            size="small"
            @click.stop="reassignGroup"
        >
            {{ i18n.t('callHistoryView.reassignAccounts') }}
        </VcButton>
        <VcButton
            v-if="isCategoryOpenable"
            icon="vc-lc-external-link"
            color="secondary"
            type="borderless"
            size="small"
            @click.stop="openCategory"
        >
            {{ i18n.t('callHistoryView.openCategory') }}
        </VcButton>
    </div>
</template>

<script setup lang="ts">
import i18n from '@/plugins/i18n.ts'
import { VcButton } from '@voicenter-team/voicenter-ui-plus'
import { UpsertDataAccountsError } from '@/types/aiManager'
import { computed, ref } from 'vue'

const props = defineProps<{
    accountGroup?: UpsertDataAccountsError
    assignedGroups?: Array<number>
}>()

const emit = defineEmits<{
    (e: 'reassignGroup', accountGroup?: UpsertDataAccountsError, ref?: HTMLElement): void
    (e: 'openCategory', categoryID?: number): void
}>()

const reassignAccountsButtonRef = ref()
const isCategoryOpenable = computed(() => props.accountGroup?.CategoryExists && !props.accountGroup.CategoryDefault)
const isCategoryReassignable = computed(() => !props.assignedGroups?.includes(props.accountGroup?.CategoryID || 0))

function reassignGroup () {
    emit('reassignGroup', props.accountGroup, reassignAccountsButtonRef.value)
}

function openCategory () {
    emit('openCategory', props.accountGroup?.CategoryID)
}
</script>
